import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  GlobalConstantsRegex,
  ValueFormat,
} from 'globales-projekt-angular';
import { WindhaeufigkeitVonBis } from 'src/app/data/user/windhaeufigkeit-von-bis.model';
import { Gebietskategorie } from 'src/app/data/ws/gebietskategorie.model';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-modal-schnelleinstellungen',
  templateUrl: './modal-schnelleinstellungen.component.html',
  styleUrls: ['./modal-schnelleinstellungen.component.css'],
})
export class ModalSchnelleinstellungenComponent implements OnInit {
  windRichtungVonList: number[] = [];
  windRichtungBisList: number[] = [];
  gebietskategorieList: Gebietskategorie[] = [];

  valueFormat: ValueFormat = new ValueFormat();

  formControlGanzZahlLaeng2NumberWarning: string =
    GlobalConstantsRegex.getRegexTextBuilderZahl(
      GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_TEXT
    );

  formControlGanzZahlLaeng2OderKomma2NumberWarning: string =
    GlobalConstantsRegex.getRegexTextBuilderZahl(
      GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_2_TEXT
    );

  windhaeufigkeitVonFormControl: FormControl =
    new FormControl(null);

  windhaeufigkeitBisFormControl: FormControl =
    new FormControl(null);

  windhaeufigkeitFormControl: FormControl =
    new FormControl(null, [
      Validators.pattern(
        GlobalConstantsRegex.GANZ_ZAHL_LAENG_2
      ),
    ]);

  hgFormControl: FormControl =
    new FormControl(null, [
      Validators.pattern(
        GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_2
      ),
    ]);

  gebietskategorieFormControl: FormControl =
    new FormControl(null);

  windhaeufigkeitBeruecksichtigenFormControl: FormControl =
    new FormControl(true);

  gebietskategorieBeruecksichtigenFormControl: FormControl =
    new FormControl(true);

  globalConstantsRegex: GlobalConstantsRegex =
    new GlobalConstantsRegex();

  constructor(private localService: LocalService) {}

  ngOnInit(): void {
    this.gebietskategorieList =
      this.localService.globalWSData.value || [];

    this.initialisiereWindrichtungen();
    this.initialisiereStandardwerte();
    this.initialisiereGebietskategorie();
    this.registriereAenderungen();

    this.setWindhaeufigkeitBeruecksichtigen(
      this.windhaeufigkeitBeruecksichtigenFormControl.value === true
    );

    this.setGebietskategorieBeruecksichtigen(
      this.gebietskategorieBeruecksichtigenFormControl.value === true
    );
  }

  private initialisiereWindrichtungen(): void {
    for (let i = 0; i < 36; i++) {
      const windrichtung = 10 * i;

      this.windRichtungVonList.push(windrichtung);
      this.windRichtungBisList.push(windrichtung);
    }

    this.windhaeufigkeitVonFormControl.setValue(
      this.windRichtungVonList[0]
    );

    this.windhaeufigkeitBisFormControl.setValue(
      this.windRichtungBisList[
        this.windRichtungBisList.length - 1
      ]
    );
  }

  private initialisiereStandardwerte(): void {
    this.windhaeufigkeitFormControl.setValue(
      this.valueFormat.getStringDecimal(0, 0)
    );

    this.hgFormControl.setValue(
      this.valueFormat.getStringDecimal(0, 2)
    );

    this.hgFormControl.disable({
      emitEvent: false,
    });
  }

  private initialisiereGebietskategorie(): void {
    const standardGebietskategorie =
      this.gebietskategorieList.find(
        (item) => item.hg === 0
      ) || this.gebietskategorieList[0];

    if (!standardGebietskategorie) {
      this.gebietskategorieFormControl.setValue(
        null,
        { emitEvent: false }
      );

      this.hgFormControl.disable({
        emitEvent: false,
      });

      return;
    }

    this.gebietskategorieFormControl.setValue(
      standardGebietskategorie.idGebietskategorie,
      { emitEvent: false }
    );

    this.onSelectGebietskategorie(
      standardGebietskategorie.idGebietskategorie
    );
  }

  private registriereAenderungen(): void {
    this.gebietskategorieFormControl.valueChanges.subscribe(
      (idGebietskategorie) => {
        this.onSelectGebietskategorie(
          idGebietskategorie
        );
      }
    );

    this.windhaeufigkeitBeruecksichtigenFormControl.valueChanges.subscribe(
      (beruecksichtigen) => {
        this.setWindhaeufigkeitBeruecksichtigen(
          beruecksichtigen === true
        );
      }
    );

    this.gebietskategorieBeruecksichtigenFormControl.valueChanges.subscribe(
      (beruecksichtigen) => {
        this.setGebietskategorieBeruecksichtigen(
          beruecksichtigen === true
        );
      }
    );
  }

  private setWindhaeufigkeitBeruecksichtigen(
    beruecksichtigen: boolean
  ): void {
    if (beruecksichtigen) {
      this.windhaeufigkeitFormControl.enable({
        emitEvent: false,
      });

      return;
    }

    this.windhaeufigkeitFormControl.disable({
      emitEvent: false,
    });
  }

  private setGebietskategorieBeruecksichtigen(
    beruecksichtigen: boolean
  ): void {
    if (!beruecksichtigen) {
      this.gebietskategorieFormControl.disable({
        emitEvent: false,
      });

      this.hgFormControl.disable({
        emitEvent: false,
      });

      return;
    }

    this.gebietskategorieFormControl.enable({
      emitEvent: false,
    });

    this.onSelectGebietskategorie(
      this.gebietskategorieFormControl.value
    );
  }

  onSelectWindrichtungVon(): void {
    const windrichtungVon =
      this.windhaeufigkeitVonFormControl.value;

    if (windrichtungVon == null) {
      this.windRichtungBisList = [];

      this.windhaeufigkeitBisFormControl.setValue(
        null
      );

      return;
    }

    this.windRichtungBisList = [];

    for (
      let i = windrichtungVon / 10;
      i < 36;
      i++
    ) {
      this.windRichtungBisList.push(10 * i);
    }

    const windrichtungBis =
      this.windhaeufigkeitBisFormControl.value;

    if (
      windrichtungBis != null &&
      windrichtungVon > windrichtungBis
    ) {
      this.windhaeufigkeitBisFormControl.setValue(
        null
      );

      this.windhaeufigkeitBisFormControl
        .markAllAsTouched();
    }
  }

  onSelectGebietskategorie(
    idGebietskategorie: number
  ): void {
    if (
      this.gebietskategorieBeruecksichtigenFormControl.value !== true
    ) {
      this.hgFormControl.disable({
        emitEvent: false,
      });

      return;
    }

    const gebietskategorie =
      this.gebietskategorieList.find(
        (item) =>
          item.idGebietskategorie ===
          idGebietskategorie
      );

    if (!gebietskategorie) {
      this.hgFormControl.disable({
        emitEvent: false,
      });

      return;
    }

    if (gebietskategorie.hg == null) {
      this.hgFormControl.enable({
        emitEvent: false,
      });

      this.hgFormControl.setValue(
        this.valueFormat.getStringDecimal(0, 2),
        { emitEvent: false }
      );

      return;
    }

    this.hgFormControl.disable({
      emitEvent: false,
    });

    this.hgFormControl.setValue(
      this.valueFormat.getStringDecimal(
        gebietskategorie.hg,
        2
      ),
      { emitEvent: false }
    );
  }

  getWindhaeufigkeitVonBis():
    Partial<WindhaeufigkeitVonBis> {

    /*
     * Dieses Objekt enthält ausschließlich die Felder,
     * die tatsächlich geändert werden sollen.
     */
    const aenderungen:
      Partial<WindhaeufigkeitVonBis> = {
        windrichtungVon:
          this.windhaeufigkeitVonFormControl.value,

        windrichtungBis:
          this.windhaeufigkeitBisFormControl.value,
      };

    if (
      this.windhaeufigkeitBeruecksichtigenFormControl.value === true
    ) {
      aenderungen.windhaeufigkeit =
        this.valueFormat.parseNumber(
          this.windhaeufigkeitFormControl.value
        );
    }

    if (
      this.gebietskategorieBeruecksichtigenFormControl.value === true
    ) {
      aenderungen.idGebietskategorie =
        this.gebietskategorieFormControl.value;

      aenderungen.hg =
        this.valueFormat.parseNumber(
          this.hgFormControl.value
        );
    }

    return aenderungen;
  }

  isFormValid(): boolean {
    const windrichtungenGueltig =
      this.windhaeufigkeitVonFormControl.value != null &&
      this.windhaeufigkeitVonFormControl.valid &&
      this.windhaeufigkeitBisFormControl.value != null &&
      this.windhaeufigkeitBisFormControl.valid;

    const windhaeufigkeitGueltig =
      this.windhaeufigkeitBeruecksichtigenFormControl.value !== true ||
      (
        this.windhaeufigkeitFormControl.value != null &&
        this.windhaeufigkeitFormControl.valid
      );

    const gebietskategorieGueltig =
      this.gebietskategorieBeruecksichtigenFormControl.value !== true ||
      (
        this.gebietskategorieFormControl.value != null &&
        this.gebietskategorieFormControl.valid &&
        (
          this.hgFormControl.disabled ||
          (
            this.hgFormControl.value != null &&
            this.hgFormControl.valid
          )
        )
      );

    return (
      windrichtungenGueltig &&
      windhaeufigkeitGueltig &&
      gebietskategorieGueltig
    );
  }
}